import React from 'react';
import { Button, CardDeck } from 'react-bootstrap';
import Article from './Article/Article';
import './Blogs.css';
import { useContext } from 'react';
import { DataContext } from '../Layouts';
import { useState } from 'react';
const Blog = () => {
    const [limit, setLimit] = useState(6);
    const {allBlogs} = useContext(DataContext);
    const limitedBlogs = allBlogs.slice(0,limit);
    return (
        <div className="my-5">
            <CardDeck className="blogs mt-5 mb-3">
                {
                    limitedBlogs.map((blog,index) =>  <Article key={index} blog={blog} />)
                }
            </CardDeck>
            {
                limit < allBlogs.length &&  <div className="text-center">
                <Button 
                onClick={() => {
                    setLimit(limit + 6)
                }}
                variant="outline-success">See More</Button>
            </div>
            }
           
        </div>
    );
};

export default Blog;